<script>
import {Carousel, Slide} from "vue-carousel";
import Layout from "@/pages/home/layout";
import vue2Dropzone from "vue2-dropzone";
import {userModel} from "@/models/userModel";
import {required, sameAs, minLength, maxLength} from "vuelidate/lib/validators";
import Avatar from 'vue-avatar'


/**
 * Crypto ICO-landing page
 */
export default {
  components: {Layout, vueDropzone: vue2Dropzone, Avatar},
  data() {
    return {
      start: "",
      end: "",
      interval: "",
      days: "",
      minutes: "",
      hours: "",
      seconds: "",
      starttime: "Nov 5, 2020 15:37:25",
      endtime: "Dec 31, 2021 16:37:25",
      url: process.env.VUE_APP_API_URL + 'files/view/',
      submitted: false,
      perPage: 10,
      currentPage: 1,
      sortBy: "age",
      sortDesc: false,
      filterOn: [],
      showImage: false,
      model: userModel.baseJson(),
      modelView: userModel.baseJson(),
      currentUserAuth: null,
      modelPass: {
        password: null,
        newPassword: null,
        confirmPassword: null,
        userName: null,
        id: null
      },
      showModal: false,
      showModalAvatar: false,
      showModalChangPassword: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        maxFilesize: 30,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif, .docx, .doc, .csv, .xlsx, .pptx, .pdf",
      },
    };
  },
  validations: {
    modelPass: {
      password: {required},
      newPassword: {
        required,
        valid: function (value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[#?!@$%^&*-]/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        },
        minLength: minLength(8),
        maxLength: maxLength(20),
      },
      confirmPassword: {required, sameAsPassword: sameAs('newPassword')}
    }
  },
  created() {
    let authUser = localStorage.getItem("auth-user");
    if (authUser) {
      let jsonUserCurrent = JSON.parse(authUser);
      this.currentUserAuth = jsonUserCurrent;
      this.modelView = jsonUserCurrent;
      console.log("CURRENT USER AUTH  created : ", this.currentUserAuth)
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  mounted() {
    this.start = new Date(this.starttime).getTime();
    this.end = new Date(this.endtime).getTime();
    // Update the count down every 1 second
    this.timerCount(this.start, this.end);
    this.interval = setInterval(() => {
      this.timerCount(this.start, this.end);
    }, 1000);

    this.totalRows = this.tableData.length;
  },
  methods: {
    timerCount: function (start, end) {
      // Get todays date and time
      var now = new Date().getTime();

      // Find the distance between now an the count down date
      var distance = start - now;
      var passTime = end - now;

      if (distance < 0 && passTime < 0) {
        clearInterval(this.interval);
        return;
      } else if (distance < 0 && passTime > 0) {
        this.calcTime(passTime);
      } else if (distance > 0 && passTime > 0) {
        this.calcTime(distance);
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    calcTime: function (dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
          (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    },
    /**
     * Window scroll method
     */
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
      ) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    },
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    removeHinhAnh(file, error, xhr) {
      let fileHinhAnh = JSON.parse(file.xhr.response);
      if (fileHinhAnh.data && fileHinhAnh.data.id) {
        let idFile = fileHinhAnh.data.id;
        let resultData = this.model.uploadFiles.filter((x) => {
          return x.fileId != idFile;
        });
        this.model.avatar = resultData;
      }
    },
    addHinhAnh(file, response) {
      if (this.model) {
        if (
            this.model.uploadFiles == null ||
            this.model.uploadFiles.length <= 0
        ) {
          this.model.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.model.avatar = {
          fileId: fileSuccess.id,
          fileName: fileSuccess.fileName,
        };
      }
    },

    /**
     * Handle edit form
     */
    async handleChangePassword(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.modelPass.$invalid) {
        console.log("LOG INVALID : ", this.submitted)
        return;
      } else {
        console.log("user", this.currentUserAuth);
        if (this.currentUserAuth.id != 0 && this.currentUserAuth.id != null && this.currentUserAuth.id) {
          if (this.currentUserAuth.newPasswordword === this.currentUserAuth.confirmPassword) {
            this.modelPass.userName = this.currentUserAuth.userName;
            await this.$store.dispatch("authDongThapStore/changePassword", this.modelPass)
                .then((res) => {
                  if (res.resultCode === "SUCCESS") {
                    this.showModalChangPassword = false;
                    this.$notify({
                      group: "foo",
                      title: "Thông báo",
                      type: "success",
                      text: "Cập nhập thông tin thành công.",
                    });

                  } else {
                    this.$notify({
                      group: "foo",
                      title: "Thông báo",
                      type: "error",
                      text: "" + res.resultString,
                    });
                  }
                });

          } else {
            this.$notify({
              group: "foo",
              title: "Thông báo",
              type: "error",
              text: "Nhập lại mật khẩu không chính xác",
            });
          }
        }
      }
    },
    /**
     * Handle change password
     */
    async handleEditForm(e) {
      console.log("LOG VAO EDIT FORM ", this.currentUserAuth);
      e.preventDefault();
      if (this.currentUserAuth.id != 0 && this.currentUserAuth.id != null && this.currentUserAuth.id) {
        console.log("id", this.currentUserAuth.id);
        // Update model
        await this.$store
            .dispatch("authDongThapStore/updateCitizen", this.model)
            .then((res) => {
              if (res.resultCode === "SUCCESS") {
                this.showModal = false;
                this.showModalAvatar = false;
                this.$notify({
                  group: "foo",
                  title: "Thông báo",
                  type: "success",
                  text: "Cập nhập thông tin thành công.",
                });
                this.getUserById();
              } else {
                this.showModal = false;
                this.$notify({
                  group: "foo",
                  title: "Thông báo",
                  type: "error",
                  text: "Cập nhập thông tin thất bại.",
                });
              }
            });
      }
    },
    avatar(value) {
      if (!value) return ''
      const nameArray = value.split(' ')
      return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
    }
  },


};
</script>

<template>
  <Layout>
    <div class="container" style="margin-bottom: 20px;">
      <div class="card-tt overflow-hidden">
        <div class="bg-soft bg-info">
          <div class="row">
            <div class="col-7">

            </div>
            <div class="col-5 align-self-end">
            </div>
          </div>
        </div>
        <div class="card-body pt-0">
          <div class="row">
            <div class="col-8">
              <div class="d-flex justify-content-start align-items-center">
                <div class="avatar-md profile-user-wid mb-5 px-5 me-3">
                  <div v-if="modelView.avatar != null" class="w-100 d-flex justify-content-center">
                    <div style="width: 100px; height: 100px;" class="position-relative">
                      <b-img
                          :src="url + `${modelView.avatar.fileId}`"
                          alt="200x200"
                          class="rounded-circle avatar-lg cs-avatar-user"
                          data-holder-rendered="true"
                          style=" object-fit: cover"
                      >
                      </b-img>
                      <button
                          type="button"
                          size="sm"
                          class="btn-outline btn-sm position-absolute border-0"
                          style="bottom: -10px; right: 15px; border-radius: 50px"
                          v-on:click="showModalAvatar = true">
                        <i class="mdi mdi-camera-outline text-black fs-3"></i>
                      </button>
                    </div>
                  </div>
                  <div v-else class="d-flex justify-content-center">
                    <div class="position-relative">
                      <avatar
                          class="d-flex justify-content-center cs-avatar-user"
                          :username="`${modelView.fullName}`"
                          :size="100"
                      >
                      </avatar>
                      <button
                          type="button"
                          size="sm"
                          class="btn-outline btn-sm position-absolute border-0"
                          style="bottom: -10px; right: 15px; border-radius: 50px"
                          v-on:click="showModalAvatar = true">
                        <i class="mdi mdi-camera-outline text-black fs-3"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <h5 v-if="modelView.userName" class="font-size-18 text-truncate text-capitalize font-weight-bold">{{ modelView.userName}}</h5>
                  <h5 v-else class="font-size-18 text-truncate text-capitalize font-weight-bold">Không có tên</h5>
                  <p v-if="modelView.fullName" class="text-muted mb-0 text-truncate">{{ modelView.fullName}}</p>
                  <p v-else class="text-muted mb-0 text-truncate">Không có email</p>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="pt-4">
                <div class="row">
                  <div class="col-12 d-flex justify-content-end">
                    <b-button
                        title="Chỉnh sửa thông tin"
                        class="cs-btn-edit-user"
                        @click="showModal = true"
                    >
                      <i class="bx bx-edit-alt fs-5 mx-1"></i>
                    </b-button>
                    <b-button
                        style="margin-left: 10px"
                        title="Đổi mật khẩu"
                        class="cs-btn-change-pass-word"
                        @click="showModalChangPassword = true"
                    >
                      <i class="bx bx-lock fs-5 mx-1"></i>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-tt">
        <div class="card-body">
          <h4 class="card-title mb-4">Thông tin cá nhân</h4>
          <div class="card-list-item-info">
            <i class="mdi mdi-phone text-black"></i>
            <p class="d-flex flex-column mb-0">
              <span v-if="modelView.phone" class="text-black">{{modelView.phone}}</span>
              <span v-else class="text-black">Không có số điện thoại</span>
              <small>Số điện thoại</small>
            </p>
          </div>
          <div class="card-list-item-info">
            <i class="mdi mdi-map-marker text-black"></i>
            <p class="d-flex flex-column mb-0">
              <span v-if="modelView.address" class="text-black">{{modelView.address}}</span>
              <span v-else class="text-black">Không có địa chỉ</span>
              <small>Địa chỉ</small>
            </p>
          </div>
          <div class="card-list-item-info">
            <i class="mdi mdi-email text-black"></i>
            <p class="d-flex flex-column mb-0">
              <span v-if="modelView.email" class="text-black">{{modelView.email}}</span>
              <span v-else class="text-black">Không có email</span>
              <small>Email</small>
            </p>
          </div>
        </div>
      </div>
    </div>
    <b-modal
        id="modal-edit"
        ref="modal"
        v-model="showModalAvatar"
        size="lg"
        title="Cập nhật ảnh đại diện"
        title-class="font-18 fw-bold"
        body-class="p-4"
        hide-footer
    >
      <div class="row justify-content-center">
        <div class="col-3 mb-3">
          <vue-dropzone
              id="customdropzone"
              ref="myVueDropzone"
              :use-custom-slot="true"
              :options="dropzoneOptions"
              v-on:vdropzone-removed-file="removeHinhAnh"
              v-on:vdropzone-success="addHinhAnh"

          >
            <div class="dropzone-custom-content">
              <i
                  class="display-1 text-muted bx bxs-cloud-upload"
                  style="font-size: 70px"
              ></i>
              <h4>
                Kéo thả tệp tin hoặc bấm vào để tải tệp tin
              </h4>
            </div>
          </vue-dropzone>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <b-button variant="danger" class="me-2" block @click="showModalAvatar = false">
          Đóng
        </b-button>
        <b-button variant="success" class="bg-color" @click="handleEditForm">
          Lưu
        </b-button>
      </div>
    </b-modal>
    <b-modal
        id="modal-edit"
        ref="modal"
        v-model="showModal"
        size="lg"
        title="Chỉnh sửa thông tin"
        title-class="font-18 fw-bold"
        body-class="p-4"
        hide-footer
    >
      <div class="row justify-content-center">
        <div class="col-12 mb-3 text-center">
          <div v-if="modelView.avatar != null">
            <b-img
                :src="url + `${modelView.avatar.fileId}`"
                alt="200x200"
                class="rounded-circle avatar-lg"
                data-holder-rendered="true"
            >
            </b-img>
          </div>
        </div>
      </div>

      <div class="edit-info-box">
        <form
            class="form-horizontal"
            role="form"
            @submit.prevent="handleEditForm"
        >
          <!--  Full name   -->
          <b-form-group
              class="mb-3"
              id="example-search"
              label-cols-sm="3"
              label-cols-lg="3"
              label="Họ và tên"
          >
            <div style="display: flex">
              <b-form-input
                  id="fullName"
                  v-model="model.lastName"
                  type="search"
                  name="fullName"
              ></b-form-input>
              <div style="width: 30px"></div>
              <b-form-input
                  id="fullName"
                  v-model="model.firstName"
                  type="search"
                  name="fullName"
              ></b-form-input>
            </div>

          </b-form-group>
          <!--  Full name   -->
<!--          <b-form-group-->
<!--              class="mb-3"-->
<!--              id="example-search"-->
<!--              label-cols-sm="3"-->
<!--              label-cols-lg="3"-->
<!--              label="Tên"-->
<!--          >-->
<!--            <b-form-input-->
<!--                id="fullName"-->
<!--                v-model="model.firstName"-->
<!--                type="search"-->
<!--                name="fullName"-->
<!--            ></b-form-input>-->
<!--          </b-form-group>-->
          <!-- Số điện thoại -->
          <b-form-group
              class="mb-3"
              id="example-search"
              label-cols-sm="3"
              label-cols-lg="3"
              label="Số điện thoại"
          >
            <b-form-input
                id="fullName"
                v-model="model.phoneNumber"
                type="search"
                name="fullName"
            ></b-form-input>
          </b-form-group>
          <!--  mail -->
          <b-form-group
              class="mb-3"
              id="example-search"
              label-cols-sm="3"
              label-cols-lg="3"
              label="Email"
          >
            <b-form-input
                id="fullName"
                v-model="model.emailAddress"
                type="search"
                name="fullName"
            ></b-form-input>
          </b-form-group>
          <!-- Địa chỉ -->
          <b-form-group
              class="mb-3"
              id="example-search"
              label-cols-sm="3"
              label-cols-lg="3"
              label="Địa chỉ"
          >
            <b-form-input
                id="fullName"
                v-model="model.address"
                type="search"
                name="fullName"
            ></b-form-input>
          </b-form-group>
          <div class="d-flex justify-content-end">
            <b-button variant="danger" class="me-2" block @click="showModal = false">
              Đóng
            </b-button>
            <b-button variant="success" class="bg-color" type="submit">
              Lưu
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>
    <!--                            Model Change Password-->
    <b-modal
        id="modal-change-password"
        size="lg"
        ref="modal"
        v-model="showModalChangPassword"
        title="Thay đổi mật khẩu"
        title-class="font-18 fw-bold"
        body-class="p-4"
        hide-footer
        centered
        no-close-on-backdrop
    >
      <div class="">
        <form
            @submit.prevent="handleChangePassword"
            class="form-horizontal"
            role="form"
        >
          <!--                                  Mật khẩu cũ  -->
          <b-form-group
              class="mb-3"
              id="example-search"
              label-cols-sm="3"
              label-cols-lg="3"
              label="Mật khẩu cũ"
          >
            <b-form-input
                id="fullName"
                v-model="modelPass.password"
                type="password"
                name="fullName"
                :class="{ 'is-invalid':
                                        submitted
                                         && $v.modelPass.password.$error }"
            >
            </b-form-input>
            <div
                v-if="submitted && $v.modelPass.password.$error"
                class="invalid-feedback"
            >
              <span v-if="!$v.modelPass.password.required">Mật khẩu không được trống.</span>
            </div>
          </b-form-group>
          <!--                                  Mật khẩu mới  -->
          <b-form-group
              class="mb-3"
              id="example-search"
              label-cols-sm="3"
              label-cols-lg="3"
              label="Mật khẩu mới"
          >
            <b-form-input
                id="fullName"
                v-model="modelPass.newPassword"
                type="password"
                name="fullName"
                :class="{ 'is-invalid':
                                        submitted
                                         && $v.modelPass.newPassword.$error }"
            >
            </b-form-input>
            <div
                v-if="submitted && $v.modelPass.newPassword.$error"
                class="invalid-feedback"
            >
              <span v-if="!$v.modelPass.newPassword.required">Mật khẩu mới không được trống.</span>
            </div>
            <div
                v-if="submitted && !$v.modelPass.newPassword.valid"
                class="invalid-feedback"
            >
              Mật khẩu cần có ít nhất một ký tự chữ hoa, một ký tự chữ thường, một số, một ký tự
              đặc biệt.
            </div>
            <div
                v-if="submitted && !$v.modelPass.newPassword.minLength"
                class="invalid-feedback"
            >
              Mật khẩu cần có ít nhất 8 ký tự.
            </div>
            <div
                v-if="submitted && !$v.modelPass.newPassword.maxLength"
                class="invalid-feedback"
            >
              Mật khẩu chỉ được tối đa 20 ký tự.
            </div>
          </b-form-group>
          <!--                                 Nhập lại mật khẩu mới -->
          <b-form-group
              class="mb-3"
              id="example-search"
              label-cols-sm="3"
              label-cols-lg="3"
              label="Nhập lại mật khẩu"
          >
            <b-form-input
                id="fullName"
                v-model="modelPass.confirmPassword"
                type="password"
                name="fullName"
                :class="{ 'is-invalid':
                                        submitted
                                         && $v.modelPass.confirmPassword.$error }"
            ></b-form-input>
            <div
                v-if="submitted && $v.modelPass.confirmPassword.$error"
                class="invalid-feedback"
            >
                                      <span
                                          v-if="!$v.modelPass.confirmPassword.required">Vui lòng nhập lại mật khẩu.</span>
            </div>
            <div
                v-if="submitted && modelPass.confirmPassword && !$v.modelPass.confirmPassword.sameAsPassword"
                class="invalid-feedback"
            >
              Nhập lại mật khẩu và mật khẩu mới không trùng khớp.
            </div>
          </b-form-group>
          <div class="d-flex justify-content-end">
            <b-button variant="danger" class="me-2" block
                      @click="showModalChangPassword= false">
              Đóng
            </b-button>
            <b-button variant="success" class="bg-color" type="submit">
              Lưu
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>
  </Layout>
</template>
<style>
.color-primary {
  /*color: #28883B;*/
  color: #cc3333;
}

.bg-primary {
  background-color: #cc3333 !important;
}


.customPagination > .page-item.active .page-link {
  /*background-color: #28883B;*/
  /*border-color: #28883B;*/
  background-color: #cc3333;
  border-color: #cc3333;
}

.lh-border {
  border-right-color: #f0f0f0;
  border-right-style: inset;
  border-right-width: 2px;
}

#customdropzone {
  background-color: orange;
  font-family: 'Arial', sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color .2s linear;
  height: 200px;
  border-radius: 50% !important;
  width: 200px;
  justify-content: start;
  padding: 0 !important;
  margin: 0 !important;
}

#customdropzone .dz-message {
  margin: 0 !important;
}

#customdropzone .dz-details {
  border-radius: 99px !important;
  margin: -2px 0px 0px -2px !important;
}

#customdropzone > .dz-preview .dz-image {
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 99px !important;
  margin-top: -2px !important;
  margin-left: -2px !important;
  width: 100% !important;
  height: 100% !important;
}

#customdropzone .dz-preview.dz-image-preview {
  width: 200px !important;
  height: 200px !important;
  margin: 0px !important;
}

.cs-img-user {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.cs-btn-edit-user,
.cs-btn-change-pass-word{
  padding: 5px 20px;
  border-radius: 3px;
}

.cs-btn-edit-user{
  background-color: #fff;
  color: #2b569a;
  border: 1px solid #204b03;
}
.cs-btn-edit-user i{
  color: #204b03;
}

.cs-btn-edit-user:hover{
  background: #204b03;
}
.cs-btn-edit-user:hover i{
  color: #fff;
}

.cs-btn-change-pass-word{
  background-color: #204b03;
}
.cs-btn-change-pass-word:hover{
  background-color: #2e6709;
}
.cs-avatar-user{
  border: 3px solid #fff;
}
.card-list-item-info{
  display: flex;
  justify-content: start;
  align-items: center;
}
.card-list-item-info i{
  font-size: 24px;
  padding: 20px;
}

.card-tt{
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  background-color: #fff;
  padding: 20px;
}

.bg-soft.bg-info{
  background-image: url("../home/bg-header-sm.jpg");
  background-size: cover;
  background-position: right;
  height: 150px;
}
</style>
